import { Box, Icon, IconButton, Typography } from "@mui/material"
import { DetailKeyValue } from "../../../../../../../components"
import { icons } from "../../../../../../../utils/icons"
import { OnlyKeepTwoDecimals } from "../../../../../../../utils/methods/removeDecimals"
import { useSectionContext } from "../contextProvider"
import { useStyles } from "./styles"
import { SectionHeaderProps } from "./types"

const SectionHeader = ({ title, displayRemoveButton, questionListDefault, isExpanded, isSectionConfig, sectionTotalPoints, provided, edit, expand, remove }: SectionHeaderProps) => {
    const styles = useStyles()
    const { totalQuestionPoints, totalSectionPoints, } = useSectionContext()
    const sectionPoints = OnlyKeepTwoDecimals({ value: (Number(totalSectionPoints) + Number(totalQuestionPoints)) })

    return (
        <Box sx={styles.container}>
            <Box sx={{ ...styles.flex, width: 'calc(100% - 290px)', position: 'relative', padding: '16px 0' }}>
                <Icon {...provided.dragHandleProps} onMouseDown={() => { if (isExpanded) { expand() } }} sx={styles.dragIcon}>{icons('drag')}</Icon>

                <Typography sx={styles.title}>{title}</Typography>
            </Box>

            <Box sx={{ ...styles.flex, width: '350px', gap: 2, justifyContent: 'end' }}>
                <DetailKeyValue
                    value={`${sectionPoints}${isSectionConfig ? ` / ${sectionTotalPoints}` : ''}`}
                    caption="Puntos"
                    name=""
                    sxContainer={styles.keyValue}
                />

                <DetailKeyValue
                    value={String(questionListDefault?.length ?? '0')}
                    caption="Preguntas"
                    name=""
                    sxContainer={styles.keyValue}
                />
                <Box sx={{ background: '#000', height: '70px', width: '1px' }} children={<></>} />

                <Box sx={styles.actionContainer}>
                    {Boolean(displayRemoveButton) && <IconButton onClick={remove} sx={styles.actionIcons}>{icons('simple-close')}</IconButton>}

                    <IconButton onClick={edit} sx={styles.actionIcons}>{icons('edit')}</IconButton>

                    {/* <IconButton onClick={actionPlan} sx={styles.actionIcons}>{icons('setting')}</IconButton> */}

                    <IconButton onClick={expand} sx={styles.actionIcons}>{icons(isExpanded ? 'fullScreenExit' : 'fullScreenOpen')}</IconButton>
                </Box>
            </Box>
        </Box>
    )
}

export { SectionHeader }
